// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductsList_container__vbSBf"};